var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LazyEmitter } from './RenderThread';
/**
 * 挽留弹窗抽象类
 */
var LeaveModel = /** @class */ (function (_super) {
    __extends(LeaveModel, _super);
    function LeaveModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 弹窗是否展示
        _this.visible = false;
        // 挽留弹窗是否发送过；
        _this.leaveMessageSended = false;
        return _this;
    }
    LeaveModel.prototype.updateQuestions = function (questions) {
        this.questions = questions;
        this.onUpdate();
    };
    LeaveModel.prototype.onUpdate = function () {
        this.emitRenderEvent('onUpdate');
    };
    LeaveModel.prototype.toggleVisible = function () {
        this.visible = !this.visible;
        this.onUpdate();
    };
    return LeaveModel;
}(LazyEmitter));
export { LeaveModel };
